import { IErknmAgreementsPetitionOrganization } from 'APIPackage/KnmModule/interfaces/IErknmAgreementsPetitionOrganization';

import { IErknmFormAgreementPetitionOrganization } from '../interfaces/IErknmFormAgreementPetitionOrganization';

export const convertAgreementsPetitionOrganizationToFormValues = (
  petitionOrganization: IErknmAgreementsPetitionOrganization | null,
): IErknmFormAgreementPetitionOrganization | undefined => {
  return {
    isAutocomplete: petitionOrganization?.isAutocomplete || undefined,
    inn: petitionOrganization?.inn || undefined,
    ogrn: petitionOrganization?.ogrn || undefined,
    organizationName: petitionOrganization?.organizationName || undefined,
    subjectType: petitionOrganization?.subjectType
      ? {
          ...petitionOrganization?.subjectType,
          id: petitionOrganization?.subjectType.title,
          label: petitionOrganization?.subjectType.title,
        }
      : undefined,
    kpp: petitionOrganization?.kpp || undefined,
    rafpNza: petitionOrganization?.rafpNza || undefined,
    country: petitionOrganization?.country
      ? {
          id: petitionOrganization?.country.id,
          title: petitionOrganization?.country.title,
          label: petitionOrganization?.country.title,
          value: petitionOrganization?.country.id,
        }
      : undefined,
    locationAddress: petitionOrganization?.locationAddress || undefined,
    factualAddress: petitionOrganization?.factualAddress || undefined,
    workAddress: petitionOrganization?.workAddress || undefined,
    snils: petitionOrganization?.snils || undefined,
    document: petitionOrganization?.document || undefined,
    checkSubjectResult: petitionOrganization?.checkSubjectResult || null,
    smevRequestStatus: petitionOrganization?.smevRequestStatus || undefined,
  };
};
